// Marketing/legal destinations reused verbatim across several standalone
// pages and modals — kept in one place so an updated Calendly link or a
// moved legal page only needs to change here, not at every call site.

export const CALENDLY_DEMO_URL =
  'https://calendly.com/astepanyan-1/15-minute-intro-call';

export const BLOG_URL = 'https://map-ai.co/blog';

export const TERMS_OF_USE_URL = 'https://map-ai.co/legal/terms-of-use';

export const PRIVACY_NOTICE_URL = 'https://map-ai.co/legal/privacy-policy';

export const ABOUT_URL = 'https://map-ai.co/about';

export const CONTACT_US_URL = 'https://map-ai.co/contact-us';

export const COOKIE_NOTICE_URL = 'https://map-ai.co/legal/cookie-notice';
